export const WEB_FORM_QUESTIONS_MAX_WIDTH = 800

export const WEB_FORM_RATING_SCALE = {
  SMALL: 5,
  LARGE: 10,
  LARGE_WITH_ZERO: 11,
}
